import { render, staticRenderFns } from "./WPage.vue?vue&type=template&id=29b78862&"
import script from "./WPage.vue?vue&type=script&lang=ts&"
export * from "./WPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports